<template>
    <div>
   <div class="stats-section-mobile">
    <div class="text-content">
      <p class="text-center policeLato  title col-sm-11 text-justify subheading font-weight-blod">
       {{ $t('apropos.stat_text_content[0]') }}
        {{ $t('apropos.stat_text_content[1]') }}
      </p>
    </div>
  </div>
  <div class="stats-section-mobile">
      <div class="stats">
      <div class="stat-item">
        <h2>2</h2>
        <p>{{ $t('apropos.data_content[2]') }}</p>
      </div>
      <div class="divider"></div>
      <div class="stat-item">
        <h2 id="devisCounterMobile"></h2>
        <p>{{ $t('apropos.data_content[3]') }}</p>
      </div>
       <div class="divider"></div>
       <div class="stat-item">
        <h2 id="PartnerCounterMobile"></h2>
        <p>{{ $t('apropos.data_content[0]') }}</p>
      </div>
    </div>
  </div>
    </div>

</template>

<script>
import {CountUp} from "countup.js";
import Api from '../../services/Api';
export default {
  name: "stats_section",
  data () {
    return {
        CountDevis: null,
        Countpartners: null,
        CountpartnersTemp: 0,
    }
  },
  methods: {
     //Nombre de devis total
    getDevisCount() {
                Api().get('devis/all')
                    .then(response => {
                        if (response) {
                            this.CountDevis = response.data.count;
                            const countUpMobile = new CountUp('devisCounterMobile', this.CountDevis, this.CountUpOptions);
                            countUpMobile.start();
                        } else {
                            this.CountDevis = 100
                            const countUpMobile = new CountUp('devisCounterMobile', this.CountDevis, this.CountUpOptions);
                            countUpMobile.start();

                        }
                    })
            },
    getPartnersCount() {
                Api().get('partenaire')
                    .then(response => {
                        if (response) {
                            this.Countpartners = response.data.count;
                          const countUpMobile = new CountUp('PartnerCounterMobile', this.Countpartners, this.CountUpOptions);
                            countUpMobile.start();
                        } else {
                            this.Countpartners = 10
                            const countUpMobile = new CountUp('PartnerCounterMobile', this.Countpartners, this.CountUpOptions);
                            countUpMobile.start();
                        }
                    })
            },
  },
  mounted() {
    this.getPartnersCount();
     this.getDevisCount();
  },
};
</script>

<style scoped>
.stats-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
    /* padding: 2rem; */
  background-color: #ffa409;
}
.stats-section-mobile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffa409;
  justify-content: center;
}

.text-content p {
  font-size: 2rem;
  color: #2b2b2b;
}

.stats {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.stat-item {
  text-align: center;
}

.stat-item h2 {
  font-size: 2.5rem;
  color: #fff; /* Blue tone */
  margin: 0;
  float: left;
}

.stat-item p {
  font-size: 1.6rem;
  color: #2b2b2b;
  font-weight: 500;
  text-align: left;
}

.divider {
  width: 2px;
  height: 50px;
  background-color: #fff;
}
.policeLato{
        font-family: Lato, "Helvetica Neue", Arial, sans-serif
    }
</style>
